// Declare Templates
var wishlistFilterTemplate = {
    // Grid Template
    'productGridItemHtml': '<div class="Grid__Cell 1/2--phone 1/3--tablet-and-up 1/4--desk">'+
                            '<div class="ProductItem">'+
                              '<div class="ProductItem__Wrapper">'+
                                '{{itemQuickAdd}}' +
								'{{itemImages}}' +
                                '{{itemLabels}}'+
                              '</div>'+
                              '{{itemInfo}}'+
                              '{{itemWishlist}}'+
                             '</div>'+
                            '</div>',
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function prepareShopifyData(data) {
	var params = {
		epi: data.epi,
		empi: data.empi,
		du: data.du
	};
	
	var itemData = {};
	var sizeIndex = 0;
	
	
	
	window._swat.getProductDetails(
		params,
		function(productJson) {
          	//console.log(productJson);
			
			for (var j = 0; j < productJson.options.length; j++) {
				if (productJson.options[j].name.includes('Size')) {
					var sizeIndex = j;
				}
			}
			
			var itemHtml = '<div>';
                
            itemHtml += wishlistFilterTemplate.productGridItemHtml;
          
			itemData = {
				wishlistId: data._id,
				title: productJson.title,
				variants: productJson.variants,
				images: productJson.images,
				price: data.pr,
				productId: data.empi,
				variantId: data.epi,
				url: data.du,
				available: productJson.available,
				price_varies: productJson.price_varies,
				compare_at_price: productJson.compare_at_price,
				compare_at_price_min: productJson.compare_at_price_min,
				compare_at_price_max: productJson.compare_at_price_max,
				compare_at_price_varies: productJson.compare_at_price_varies,
				price_min: productJson.price_min,
				price_max: productJson.price_max,
				size_index: sizeIndex
			};
          
          	//console.log(itemData);
			
		    itemHtml = itemHtml.replace(/{{itemLabels}}/g, '');
		    itemHtml = itemHtml.replace(/{{itemTagLabels}}/g, '');
		    itemHtml = itemHtml.replace(/{{itemQuickAdd}}/g, buildQuickAdd(itemData));
			itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(itemData));
			
			itemHtml = itemHtml.replace(/{{itemWishlist}}/g, buildWishlistRemove(itemData));
			
		    itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(itemData));
			
			itemHtml = itemHtml.replace(/{{itemUrl}}/g, itemData.url);
			
			
		
          
          	itemHtml += '</div>';

		 	$('#wishlist-items-container').append($(itemHtml).html());
			
			priceConversion();
		},
		function(e) {
			var wishlistItemId = data._id;
	
			_swat.deleteEvent(function callback() {
				window._swat.wishlistCount(
				  function(r) {
					  if (r > 0) {
						  $('.iWishCount').removeClass('WishlistEmpty');
					  } else {
						  $('.iWishCount').addClass('WishlistEmpty');
					  };
					  $('.iWishCount').html(r);
					  $('.Header__SecondaryNav span.Header__CartCount').html(r);
				  }
				);
			}, wishlistItemId);
			
			return ''
		}
	);
}

function buildInfo(data) {
  var html = '';
    html += '<div class="ProductItem__Info ProductItem__Info--center">';
    html += '<h2 class="ProductItem__Title Heading">';
    html += '<a href="{{itemUrl}}">' + data.title + '</a>';
    html += '</h2>';
    html += buildPrice(data);
    html += '</div>';
  return html;
}

function buildWishlistRemove(data) {
	return '<a class="remove-from-wishlist" data-action="remove-from-wishlist" data-wishlist-item-id="' + data.wishlistId + '">Remove from Wishlist</a>'
}

function buildQuickAdd(data) {
  var htmlQuickAdd = '';
  var sizeIndex = data.size_index;
  if (data.variants.length > 0) {
	   htmlQuickAdd += '<div class="quick-add">';
	   htmlQuickAdd += '<span class="quick-add-title">Quick Add</span>';
	   htmlQuickAdd += '<ul class="quick-add-sizes">';
	   for (var j = 0; j < data.variants.length; j++) {
		   if (data.variants[j].available) {
			   htmlQuickAdd += '<li class="quick-add-size in-stock">';
			   htmlQuickAdd += '<a class="swatch" data-action="quick-add-to-cart" data-variant-id="' + data.variants[j].id + '">' + data.variants[j].options[sizeIndex] + '</a>';
		   } else {
			   htmlQuickAdd += '<li class="quick-add-size out-of-stock">';
			   htmlQuickAdd += '<span class="swatch" data-variant-id="' + data.variants[j].id + '">' + data.variants[j].options[sizeIndex] + '</span>';
		   };
		   htmlQuickAdd += '</li>';
	   };
	   htmlQuickAdd += '</ul>';
	   htmlQuickAdd += '</div>';
  }
  return htmlQuickAdd;
}


function priceConversion() {
  var moneyFormats = {
    "USD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} USD"
    },
    "EUR": {
      "money_format": "&euro;{{amount}}",
      "money_with_currency_format": "&euro;{{amount}} EUR"
    },
    "GBP": {
      "money_format": "&pound;{{amount}}",
      "money_with_currency_format": "&pound;{{amount}} GBP"
    },
    "CAD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} CAD"
    },
    "ALL": {
      "money_format": "Lek {{amount}}",
      "money_with_currency_format": "Lek {{amount}} ALL"
    },
    "DZD": {
      "money_format": "DA {{amount}}",
      "money_with_currency_format": "DA {{amount}} DZD"
    },
    "AOA": {
      "money_format": "Kz{{amount}}",
      "money_with_currency_format": "Kz{{amount}} AOA"
    },
    "ARS": {
      "money_format": "${{amount_with_comma_separator}}",
      "money_with_currency_format": "${{amount_with_comma_separator}} ARS"
    },
    "AMD": {
      "money_format": "{{amount}} AMD",
      "money_with_currency_format": "{{amount}} AMD"
    },
    "AWG": {
      "money_format": "Afl{{amount}}",
      "money_with_currency_format": "Afl{{amount}} AWG"
    },
    "AUD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} AUD"
    },
    "BBD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} Bds"
    },
    "AZN": {
      "money_format": "m.{{amount}}",
      "money_with_currency_format": "m.{{amount}} AZN"
    },
    "BDT": {
      "money_format": "Tk {{amount}}",
      "money_with_currency_format": "Tk {{amount}} BDT"
    },
    "BSD": {
      "money_format": "BS${{amount}}",
      "money_with_currency_format": "BS${{amount}} BSD"
    },
    "BHD": {
      "money_format": "{{amount}} BD",
      "money_with_currency_format": "{{amount}} BHD"
    },
    "BYR": {
      "money_format": "Br {{amount}}",
      "money_with_currency_format": "Br {{amount}} BYR"
    },
    "BZD": {
      "money_format": "BZ${{amount}}",
      "money_with_currency_format": "BZ${{amount}} BZD"
    },
    "BTN": {
      "money_format": "Nu {{amount}}",
      "money_with_currency_format": "Nu {{amount}} BTN"
    },
    "BAM": {
      "money_format": "KM {{amount_with_comma_separator}}",
      "money_with_currency_format": "KM {{amount_with_comma_separator}} BAM"
    },
    "BRL": {
      "money_format": "R$ {{amount_with_comma_separator}}",
      "money_with_currency_format": "R$ {{amount_with_comma_separator}} BRL"
    },
    "BOB": {
      "money_format": "Bs{{amount_with_comma_separator}}",
      "money_with_currency_format": "Bs{{amount_with_comma_separator}} BOB"
    },
    "BWP": {
      "money_format": "P{{amount}}",
      "money_with_currency_format": "P{{amount}} BWP"
    },
    "BND": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} BND"
    },
    "BGN": {
      "money_format": "{{amount}} Ð»Ð²",
      "money_with_currency_format": "{{amount}} Ð»Ð² BGN"
    },
    "MMK": {
      "money_format": "K{{amount}}",
      "money_with_currency_format": "K{{amount}} MMK"
    },
    "KHR": {
      "money_format": "KHR{{amount}}",
      "money_with_currency_format": "KHR{{amount}}"
    },
    "KYD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} KYD"
    },
    "XAF": {
      "money_format": "FCFA{{amount}}",
      "money_with_currency_format": "FCFA{{amount}} XAF"
    },
    "CLP": {
      "money_format": "${{amount_no_decimals}}",
      "money_with_currency_format": "${{amount_no_decimals}} CLP"
    },
    "CNY": {
      "money_format": "&#165;{{amount}}",
      "money_with_currency_format": "&#165;{{amount}} CNY"
    },
    "COP": {
      "money_format": "${{amount_with_comma_separator}}",
      "money_with_currency_format": "${{amount_with_comma_separator}} COP"
    },
    "CRC": {
      "money_format": "&#8353; {{amount_with_comma_separator}}",
      "money_with_currency_format": "&#8353; {{amount_with_comma_separator}} CRC"
    },
    "HRK": {
      "money_format": "{{amount_with_comma_separator}} kn",
      "money_with_currency_format": "{{amount_with_comma_separator}} kn HRK"
    },
    "CZK": {
      "money_format": "{{amount_with_comma_separator}} K&#269;",
      "money_with_currency_format": "{{amount_with_comma_separator}} K&#269;"
    },
    "DKK": {
      "money_format": "{{amount_with_comma_separator}}",
      "money_with_currency_format": "kr.{{amount_with_comma_separator}}"
    },
    "DOP": {
      "money_format": "RD$ {{amount}}",
      "money_with_currency_format": "RD$ {{amount}}"
    },
    "XCD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "EC${{amount}}"
    },
    "EGP": {
      "money_format": "LE {{amount}}",
      "money_with_currency_format": "LE {{amount}} EGP"
    },
    "ETB": {
      "money_format": "Br{{amount}}",
      "money_with_currency_format": "Br{{amount}} ETB"
    },
    "XPF": {
      "money_format": "{{amount_no_decimals_with_comma_separator}} XPF",
      "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    "FJD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "FJ${{amount}}"
    },
    "GMD": {
      "money_format": "D {{amount}}",
      "money_with_currency_format": "D {{amount}} GMD"
    },
    "GHS": {
      "money_format": "GH&#8373;{{amount}}",
      "money_with_currency_format": "GH&#8373;{{amount}}"
    },
    "GTQ": {
      "money_format": "Q{{amount}}",
      "money_with_currency_format": "{{amount}} GTQ"
    },
    "GYD": {
      "money_format": "G${{amount}}",
      "money_with_currency_format": "${{amount}} GYD"
    },
    "GEL": {
      "money_format": "{{amount}} GEL",
      "money_with_currency_format": "{{amount}} GEL"
    },
    "HNL": {
      "money_format": "L {{amount}}",
      "money_with_currency_format": "L {{amount}} HNL"
    },
    "HKD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "HK${{amount}}"
    },
    "HUF": {
      "money_format": "{{amount_no_decimals_with_comma_separator}}",
      "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    "ISK": {
      "money_format": "{{amount_no_decimals}} kr",
      "money_with_currency_format": "{{amount_no_decimals}} kr ISK"
    },
    "INR": {
      "money_format": "Rs. {{amount}}",
      "money_with_currency_format": "Rs. {{amount}}"
    },
    "IDR": {
      "money_format": "{{amount_with_comma_separator}}",
      "money_with_currency_format": "Rp {{amount_with_comma_separator}}"
    },
    "ILS": {
      "money_format": "{{amount}} NIS",
      "money_with_currency_format": "{{amount}} NIS"
    },
    "JMD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} JMD"
    },
    "JPY": {
      "money_format": "&#165;{{amount_no_decimals}}",
      "money_with_currency_format": "&#165;{{amount_no_decimals}} JPY"
    },
    "JEP": {
      "money_format": "&pound;{{amount}}",
      "money_with_currency_format": "&pound;{{amount}} JEP"
    },
    "JOD": {
      "money_format": "{{amount}}0 JD",
      "money_with_currency_format": "{{amount}}0 JOD"
    },
    "KZT": {
      "money_format": "{{amount}} KZT",
      "money_with_currency_format": "{{amount}} KZT"
    },
    "KES": {
      "money_format": "KSh{{amount}}",
      "money_with_currency_format": "KSh{{amount}}"
    },
    "KWD": {
      "money_format": "{{amount}} KD",
      "money_with_currency_format": "{{amount}} KWD"
    },
    "KGS": {
      "money_format": "Ð»Ð²{{amount}}",
      "money_with_currency_format": "Ð»Ð²{{amount}}"
    },
    "LVL": {
      "money_format": "Ls {{amount}}",
      "money_with_currency_format": "Ls {{amount}} LVL"
    },
    "LBP": {
      "money_format": "L&pound;{{amount}}",
      "money_with_currency_format": "L&pound;{{amount}} LBP"
    },
    "LTL": {
      "money_format": "{{amount}} Lt",
      "money_with_currency_format": "{{amount}} Lt"
    },
    "MGA": {
      "money_format": "Ar {{amount}}",
      "money_with_currency_format": "Ar {{amount}} MGA"
    },
    "MKD": {
      "money_format": "Ð´ÐµÐ½ {{amount}}",
      "money_with_currency_format": "Ð´ÐµÐ½ {{amount}} MKD"
    },
    "MOP": {
      "money_format": "MOP${{amount}}",
      "money_with_currency_format": "MOP${{amount}}"
    },
    "MVR": {
      "money_format": "Rf{{amount}}",
      "money_with_currency_format": "Rf{{amount}} MRf"
    },
    "MXN": {
      "money_format": "$ {{amount}}",
      "money_with_currency_format": "$ {{amount}} MXN"
    },
    "MYR": {
      "money_format": "RM{{amount}} MYR",
      "money_with_currency_format": "RM{{amount}} MYR"
    },
    "MUR": {
      "money_format": "Rs {{amount}}",
      "money_with_currency_format": "Rs {{amount}} MUR"
    },
    "MDL": {
      "money_format": "{{amount}} MDL",
      "money_with_currency_format": "{{amount}} MDL"
    },
    "MAD": {
      "money_format": "{{amount}} dh",
      "money_with_currency_format": "Dh {{amount}} MAD"
    },
    "MNT": {
      "money_format": "{{amount_no_decimals}} &#8366",
      "money_with_currency_format": "{{amount_no_decimals}} MNT"
    },
    "MZN": {
      "money_format": "{{amount}} Mt",
      "money_with_currency_format": "Mt {{amount}} MZN"
    },
    "NAD": {
      "money_format": "N${{amount}}",
      "money_with_currency_format": "N${{amount}} NAD"
    },
    "NPR": {
      "money_format": "Rs{{amount}}",
      "money_with_currency_format": "Rs{{amount}} NPR"
    },
    "ANG": {
      "money_format": "&fnof;{{amount}}",
      "money_with_currency_format": "{{amount}} NA&fnof;"
    },
    "NZD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} NZD"
    },
    "NIO": {
      "money_format": "C${{amount}}",
      "money_with_currency_format": "C${{amount}} NIO"
    },
    "NGN": {
      "money_format": "&#8358;{{amount}}",
      "money_with_currency_format": "&#8358;{{amount}} NGN"
    },
    "NOK": {
      "money_format": "kr {{amount_with_comma_separator}}",
      "money_with_currency_format": "kr {{amount_with_comma_separator}} NOK"
    },
    "OMR": {
      "money_format": "{{amount_with_comma_separator}} OMR",
      "money_with_currency_format": "{{amount_with_comma_separator}} OMR"
    },
    "PKR": {
      "money_format": "Rs.{{amount}}",
      "money_with_currency_format": "Rs.{{amount}} PKR"
    },
    "PGK": {
      "money_format": "K {{amount}}",
      "money_with_currency_format": "K {{amount}} PGK"
    },
    "PYG": {
      "money_format": "Gs. {{amount_no_decimals_with_comma_separator}}",
      "money_with_currency_format": "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    "PEN": {
      "money_format": "S/. {{amount}}",
      "money_with_currency_format": "S/. {{amount}} PEN"
    },
    "PHP": {
      "money_format": "&#8369;{{amount}}",
      "money_with_currency_format": "&#8369;{{amount}} PHP"
    },
    "PLN": {
      "money_format": "{{amount_with_comma_separator}} zl",
      "money_with_currency_format": "{{amount_with_comma_separator}} zl PLN"
    },
    "QAR": {
      "money_format": "QAR {{amount_with_comma_separator}}",
      "money_with_currency_format": "QAR {{amount_with_comma_separator}}"
    },
    "RON": {
      "money_format": "{{amount_with_comma_separator}} lei",
      "money_with_currency_format": "{{amount_with_comma_separator}} lei RON"
    },
    "RUB": {
      "money_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
      "money_with_currency_format": "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    "RWF": {
      "money_format": "{{amount_no_decimals}} RF",
      "money_with_currency_format": "{{amount_no_decimals}} RWF"
    },
    "WST": {
      "money_format": "WS$ {{amount}}",
      "money_with_currency_format": "WS$ {{amount}} WST"
    },
    "SAR": {
      "money_format": "{{amount}} SR",
      "money_with_currency_format": "{{amount}} SAR"
    },
    "STD": {
      "money_format": "Db {{amount}}",
      "money_with_currency_format": "Db {{amount}} STD"
    },
    "RSD": {
      "money_format": "{{amount}} RSD",
      "money_with_currency_format": "{{amount}} RSD"
    },
    "SCR": {
      "money_format": "Rs {{amount}}",
      "money_with_currency_format": "Rs {{amount}} SCR"
    },
    "SGD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} SGD"
    },
    "SYP": {
      "money_format": "S&pound;{{amount}}",
      "money_with_currency_format": "S&pound;{{amount}} SYP"
    },
    "ZAR": {
      "money_format": "R {{amount}}",
      "money_with_currency_format": "R {{amount}} ZAR"
    },
    "KRW": {
      "money_format": "&#8361;{{amount_no_decimals}}",
      "money_with_currency_format": "&#8361;{{amount_no_decimals}} KRW"
    },
    "LKR": {
      "money_format": "Rs {{amount}}",
      "money_with_currency_format": "Rs {{amount}} LKR"
    },
    "SEK": {
      "money_format": "{{amount_no_decimals}} kr",
      "money_with_currency_format": "{{amount_no_decimals}} kr SEK"
    },
    "CHF": {
      "money_format": "{{amount}} CHF",
      "money_with_currency_format": "{{amount}} CHF"
    },
    "TWD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} TWD"
    },
    "THB": {
      "money_format": "{{amount}} &#xe3f;",
      "money_with_currency_format": "{{amount}} &#xe3f; THB"
    },
    "TZS": {
      "money_format": "{{amount}} TZS",
      "money_with_currency_format": "{{amount}} TZS"
    },
    "TTD": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}} TTD"
    },
    "TND": {
      "money_format": "{{amount}}",
      "money_with_currency_format": "{{amount}} DT"
    },
    "TRY": {
      "money_format": "{{amount}}TL",
      "money_with_currency_format": "{{amount}}TL"
    },
    "UGX": {
      "money_format": "Ush {{amount_no_decimals}}",
      "money_with_currency_format": "Ush {{amount_no_decimals}} UGX"
    },
    "UAH": {
      "money_format": "â‚´{{amount}}",
      "money_with_currency_format": "â‚´{{amount}} UAH"
    },
    "AED": {
      "money_format": "Dhs. {{amount}}",
      "money_with_currency_format": "Dhs. {{amount}} AED"
    },
    "UYU": {
      "money_format": "${{amount_with_comma_separator}}",
      "money_with_currency_format": "${{amount_with_comma_separator}} UYU"
    },
    "VUV": {
      "money_format": "${{amount}}",
      "money_with_currency_format": "${{amount}}VT"
    },
    "VEF": {
      "money_format": "Bs. {{amount_with_comma_separator}}",
      "money_with_currency_format": "Bs. {{amount_with_comma_separator}} VEF"
    },
    "VND": {
      "money_format": "{{amount_no_decimals_with_comma_separator}}&#8363;",
      "money_with_currency_format": "{{amount_no_decimals_with_comma_separator}} VND"
    },
    "XBT": {
      "money_format": "{{amount_no_decimals}} BTC",
      "money_with_currency_format": "{{amount_no_decimals}} BTC"
    },
    "XOF": {
      "money_format": "CFA{{amount}}",
      "money_with_currency_format": "CFA{{amount}} XOF"
    },
    "ZMW": {
      "money_format": "K{{amount_no_decimals_with_comma_separator}}",
      "money_with_currency_format": "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
  };

  var baseCurrency = window.theme.shopCurrency,
      newCurrency = document.querySelector('.CurrencySelector__Select').value;

  	document.querySelectorAll('[data-money-convertible]').forEach(function (item) {
  		if (!item.hasAttribute('data-currency-' + baseCurrency)) {
  			item.setAttribute('data-currency-' + baseCurrency, item.innerHTML);
  		}

            // If the amount has already been converted, we leave it alone.
  		if (item.getAttribute('data-currency') === newCurrency) {
  			return;
  		}

  		var baseAmount = item.getAttribute('data-currency-' + baseCurrency);

            // If we are converting to a currency that we have saved, we will use the saved amount.
  		if (item.hasAttribute('data-currency-' + newCurrency)) {
  			item.innerHTML = item.getAttribute('data-currency-' + newCurrency);
  		} else {
  			var newFormat = moneyFormats[newCurrency][window.theme.currencyConversionMoneyFormat] || '{{amount}}';

  			// We have to normalize by replacing dot by comma and comma by dot
  			if (window.theme.moneyFormat.indexOf('with_comma_separator') !== -1) {
  				baseAmount = baseAmount.replace(/[,.]/g, function (match) {
  					// If `,` is matched return `.`, if `.` matched return `,`
  					return match === ',' ? '.' : ',';
  				});
  			}

              // Converting to Y for the first time? Let's get to it!
  			var cents = window.Currency.convert(parseFloat(baseAmount.replace(/^[^0-9]+|[^0-9.]/g, '', ''), 10) * 100, baseCurrency, newCurrency);

              if (window.theme.currencyConversionRoundAmounts) {
                cents = Math.round(cents / 100) * 100;
              }

              var newFormattedAmount = Shopify.formatMoney(cents, newFormat);

              item.innerHTML = newFormattedAmount;
              item.setAttribute('data-currency-' + newCurrency, newFormattedAmount);
            }

            // We record the new currency locally.
            item.setAttribute('data-currency', newCurrency);
          });
}





function buildPrice(data) {
	var onSale = data.compare_at_price_min > data.price_min;
	var priceVaries = data.price_min != data.price_max;

	var html = '';
    html += '<div class="ProductItem__PriceList ProductItem__PriceList--showOnHover Heading">';
	if (onSale) {
		html += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible>' + Shopify.formatMoney((Math.round(data.price_min) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat) + '</span> ';
		html += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible>' + Shopify.formatMoney((Math.round(data.compare_at_price_min) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat) + '</span>';
	} else {
		if (priceVaries) {
			html += 'From ';
		}
		html += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Shopify.formatMoney((Math.round(data.price_min) / 100).toFixed(2),window.theme.moneyWithCurrencyFormat) + '</span>';
	}
    html += '</div>';
	
	return html;
}

function buildImages(data) {
    var images = data.images;
	
	var htmlImg = '';
    if (images.length > 0) {
      htmlImg += '<a href="{{itemUrl}}" class="ProductDefaultView ProductItem__ImageWrapper ';
      var use_natural_size = true;
      var has_alternate_image = false;
	  
	  if (images.length > 1)
        has_alternate_image = true;
      
      if (has_alternate_image)
        htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
      htmlImg += '">';
      var max_width = 594;
      
      var withCall = 'withFallback';
      htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
      
	  if (use_natural_size) {
        htmlImg += 'padding-bottom: 133.33333333333334%;';
      }
      htmlImg += ' --aspect-ratio: 0.75">';
	  
	  if (has_alternate_image && images.length > 1) {
        var sizes = '200,300,400,600,800,900,1000,1200';
        htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + images[1] + '" data-widths="[' + sizes + ']" data-sizes="auto" alt="' + data.title + '">';
      }

      var sizes_main = '200,400,600,700,800,900,1000,1200';
      htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + images[0] + '" data-widths="[' + sizes_main + ']" data-sizes="auto" alt="' + data.title + '">';
      htmlImg += '<span class="Image__Loader"></span>';
      htmlImg += '</div>';
      htmlImg += '</a>';
	  
	  var alternate_front = images.length - 1;
	  var alternate_back = alternate_front - 1;
	  
      htmlImg += '<a href="{{itemUrl}}" class="ProductAlternateView ProductItem__ImageWrapper ';
      if (has_alternate_image)
        htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
      htmlImg += '">';
      
      htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
	  
	  if (use_natural_size) {
        htmlImg += 'padding-bottom: 133.33333333333334%;';
      }
      htmlImg += ' --aspect-ratio: 0.75">';
      
	  if (has_alternate_image && images.length > 1) {
        var sizes = '200,300,400,600,800,900,1000,1200';
        htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + images[alternate_back] + '" data-widths="[' + sizes + ']" data-sizes="auto" alt="' + data.title + '">';
      }

      htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + images[alternate_front] + '" data-widths="[' + sizes_main + ']" data-sizes="auto" alt="' + data.title + '">';
      htmlImg += '<span class="Image__Loader"></span>';
      htmlImg += '</div>';
      htmlImg += '</a>';
	  
	  
    }
    return htmlImg;
}

$(document).on('click', 'a[data-action="remove-from-wishlist"]', function () {
	var el = $(this);
	var wishlistItemId = $(this).attr('data-wishlist-item-id');
	
	_swat.deleteEvent(function callback() {
		console.log(el);
		$(el).closest('.Grid__Cell').fadeOut();
		window._swat.wishlistCount(
		  function(r) {
			  if (r > 0) {
				  $('.iWishCount').removeClass('WishlistEmpty');
			  } else {
				  $('.iWishCount').addClass('WishlistEmpty');
			  };
			  $('.iWishCount').html(r);
			  $('.Header__SecondaryNav span.Header__CartCount').html(r);
		  }
		);
	}, wishlistItemId);
});

function swymCallbackFn(){
  // gets called once Swym is ready
  var wishlistContentsContainer = document.getElementById("wishlist-items-container");
  var productCardsMarkup = '';
  
  _swat.fetchWrtEventTypeET(
    function(products) {
      // Get wishlist items
      
      for (var j = 0; j < products.length; j++) {
      	prepareShopifyData(products[j]);
      }
	  
	  
      
    },
    window._swat.EventTypes.addToWishList
  );
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);